import React from "react";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

const CourseShowModal = (props) => {
  const [show, setShow] = useState(props.show);

  const handleClose = () => {
    setShow(false);
    props.handelCloseShow(false);
  };
  console.log(props.courseData);

  return (
    <Modal className="course-modal" size="lg" onHide={handleClose} show={show}>
      <Modal.Header>
        <Modal.Title className="dis-con">
          <h3 className="color-white">
            {props.courseData && props.courseData.name}
          </h3>
          <Button className="btn-common" onClick={handleClose}>
          <i class="fa fa-times" aria-hidden="true"></i>
          </Button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div class="paths-content-description">
          <p></p>
          <div class="paths-content-highlight paths-aside-box show-for-large-up">
            <div class="paths-aside-scrollable">
              <div className="row">
                {props.courseData &&
                  props.courseData.modules.map((li, i) => (
                    <div className="col-lg-6 mb-2" key={i}>
                      <h4 className="color-white">{i + 1 + ") " + li.name}</h4>
                      {li.topics &&
                        li.topics.map((tp, i) => (
                          <ul key={i}>
                            <li>{tp.name}</li>
                          </ul>
                        ))}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

      {/*  <Modal.Footer>
        <div className="row">
          <div className="col-6 text-left pl-0"></div>
          <div className="col-6 text-right">
            <Button variant="outline-info" onClick={handleClose}>
              Close
            </Button>
          </div>
        </div>
      </Modal.Footer>
                        */}
    </Modal>
  );
};

export default CourseShowModal;
